import { isAfter, isBefore } from "date-fns";
import { object, string, date } from "yup";

import { PreciselyAddressWithUnit } from "@covertree/features";
import { SelectOption } from "@covertree/ui";
import { postCode } from "@covertree/utils";

export interface PolicyDetailsForm {
  dateOfLoss: Date;
  address: SelectOption<PreciselyAddressWithUnit>;
  lotUnit?: string;
}

export const defaultValues: PolicyDetailsForm = {
  dateOfLoss: undefined,
  address: undefined,
  lotUnit: "",
};

export const policyDetailsFormValidator = object({
  address: object({
    label: string().required(
      "You must select an address from the dropdown menu to continue"
    ),
    value: object({
      formattedAddress: string().required(),
      streetName: string().required("Street name is missing"),
      city: string().required("City is missing"),
      country: string().required("Country is missing"),
      addressLastLine: string().required(),
      mainAddressLine: string().required(),
      state: string().required("State is missing"),
      addressNumber: string().nullable(),
      postCode: postCode(),
      lotUnit: string().nullable(),
    }),
  })
    .typeError("Address is required")
    .required("Address is required"),
  dateOfLoss: date()
    .test(
      "dateOfLoss",
      `Date of loss should be between January 1, 1900 and present day`,
      (value?: Date) => {
        if (!value) return false;
        value.setHours(0);

        const currentDate = new Date();
        return (
          isAfter(value, Date.UTC(1900, 0, 0)) && isBefore(value, currentDate)
        );
      }
    )
    .nullable()
    .typeError("Invalid Date"),
  lotUnit: string().nullable(),
});
